import { render, staticRenderFns } from "./sg-workspace.html?vue&type=template&id=1dec0d2e&scoped=true&external"
import script from "./sg-workspace.js?vue&type=script&lang=js&external"
export * from "./sg-workspace.js?vue&type=script&lang=js&external"
import style0 from "./sg-workspace.scss?vue&type=style&index=0&id=1dec0d2e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dec0d2e",
  null
  
)

export default component.exports